'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotSurfaceIcon = function PlotSurfaceIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M23.375 15.75c-1.813-.563-2.813-3-2.813-3-.063-.25-.563-1.313-.563-1.563a93.2 93.2 0 0 1-.688-2.125l-.375-.813c-.25-.5-.688-1.375-1.25-2.063l-.313-.313-.25-.188c-.375-.25-.688-.375-1.063-.375s-1.063.188-1.563.688l-.5.688a5.836 5.836 0 0 1-.313.5c-.125.25-.313.563-.438.875l.125-.25-.375.75s-.438 1.063-.563 1.563c0 0-.25.75-.313 1.125 0-.125.063-.313.063-.438l-.313 1.063c-.25.438-.5 1.125-.5 1.125-.5.688-.875 2-3.188 2.875l-2.938 1-5.25 1.813 16 8 16-8zm-11.312-4.312c0 .063-.063.125-.125.188.063-.063.063-.125.125-.188z' })
    );
};

exports.default = PlotSurfaceIcon;